export default "__VITE_ASSET__DLt3UYx___"